var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4375 3.75C7.4375 2.61 8.36 1.6875 9.5 1.6875C10.64 1.6875 11.5625 2.61 11.5625 3.75C11.5625 4.89 10.64 5.8125 9.5 5.8125C8.36 5.8125 7.4375 4.89 7.4375 3.75ZM10.4375 3.75C10.4375 3.2325 10.0175 2.8125 9.5 2.8125C8.9825 2.8125 8.5625 3.2325 8.5625 3.75C8.5625 4.2675 8.9825 4.6875 9.5 4.6875C10.0175 4.6875 10.4375 4.2675 10.4375 3.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4375 14.25C7.4375 13.11 8.36 12.1875 9.5 12.1875C10.64 12.1875 11.5625 13.11 11.5625 14.25C11.5625 15.39 10.64 16.3125 9.5 16.3125C8.36 16.3125 7.4375 15.39 7.4375 14.25ZM10.4375 14.25C10.4375 13.7325 10.0175 13.3125 9.5 13.3125C8.9825 13.3125 8.5625 13.7325 8.5625 14.25C8.5625 14.7675 8.9825 15.1875 9.5 15.1875C10.0175 15.1875 10.4375 14.7675 10.4375 14.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4375 9C7.4375 7.86 8.36 6.9375 9.5 6.9375C10.64 6.9375 11.5625 7.86 11.5625 9C11.5625 10.14 10.64 11.0625 9.5 11.0625C8.36 11.0625 7.4375 10.14 7.4375 9ZM10.4375 9C10.4375 8.4825 10.0175 8.0625 9.5 8.0625C8.9825 8.0625 8.5625 8.4825 8.5625 9C8.5625 9.5175 8.9825 9.9375 9.5 9.9375C10.0175 9.9375 10.4375 9.5175 10.4375 9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionIcon);
export default __webpack_public_path__ + "static/media/action-icon.d1b9e586b68ec26cfebf4190bb0a7133.svg";
export { ForwardRef as ReactComponent };